import { BaseModel } from './base';

// Enums

export enum CustomPageState {
  draft = 0,
  published = 1,
}

export const CustomPageStateLabels: Record<CustomPageState, string> = {
  [CustomPageState.draft]: 'general.draft',
  [CustomPageState.published]: 'customPage.published',
};

// Main Model

export class CustomPage extends BaseModel {
  pageIdentifier!: string;
  state!: CustomPageState;

  override objectID(): string | null {
    return this.pageIdentifier ?? null;
  }

  get isStatusDraft(): boolean {
    return this.state === CustomPageState.draft;
  }

  get isStatusPublished(): boolean {
    return this.state === CustomPageState.published;
  }
}
